import { useMemo } from "react";
import useUiContext from "@/custolink-hooks/useUiContext";
import Avatar from "@/components/ui/Avatar/Avatar";
import { i18nQueryStringParamName } from "@/i18n";
import Select, { Option as DefaultOption } from "@/components/ui/Select";
import { components } from "react-select";

import type { ControlProps, OptionProps } from "react-select";
import { countries } from "@/custolink-constants/i18n.constant";

const { Control } = components;

type Option = {
  value: string;
  label: string;
  imgPath: string;
};

function useLanguageSelection() {
  const uic = useUiContext();

  const languages = useMemo(() => {
    return countries
      .filter((c) =>
        uic.organisationContext.assetFrontendi18nLanguageCodes.includes(c.code),
      )
  }, [uic.organisationContext.assetFrontendi18nLanguageCodes]);
  return {
    languages,
    selectedLanguage: uic.assetFrontendlanguageCode,
  };
}

const CustomSelectOption = (props: OptionProps<Option>) => {
  return (
    <DefaultOption<Option>
      {...props}
      customLabel={(data, label) => (
        <span className="flex items-center gap-2">
          <Avatar shape="circle" size={20} src={data.imgPath} />
          <span className="ml-2 rtl:mr-2">{label}</span>
        </span>
      )}
    />
  );
};

const CustomControl = ({ children, ...props }: ControlProps<Option>) => {
  const selected = props.getValue()[0];
  return (
    // @ts-expect-error This IS OK
    <Control {...props}>
      {selected && (
        <Avatar
          className="ltr:ml-4 rtl:mr-4"
          shape="circle"
          size={18}
          src={selected.imgPath}
        />
      )}
      {children}
    </Control>
  );
};

export const LanguageSelect = () => {
  const uls = useLanguageSelection();

  const countryOptions = useMemo(() => {
    return uls.languages.map((l) => {
      return {
        value: l.code,
        label: l.name,
        imgPath: `/img/countries/${l.icon}.png`,
      };
    });
  }, [uls.languages]);

  const wal = useMemo(() => {
    return countryOptions.find((s) => s.value == uls.selectedLanguage);
  }, [uls.selectedLanguage, countryOptions]);

  return (
    <div>
      <Select<Option>
        options={countryOptions}
        components={{
          Option: CustomSelectOption,
          Control: CustomControl,
        }}
        value={wal}
        className="mb-4"
        onChange={(v) => {
          // We force a reload using an i18n query string. In the future we should switch to i18n.changeLanguage
          if (v != null) {
            const url = new URL(window.location.href);
            url.searchParams.set(i18nQueryStringParamName, v.value);
            document.location.href = url.toString();
          }
        }}
      />
    </div>
  );
};
